import { render, staticRenderFns } from "./QuestionsCreate.vue?vue&type=template&id=621baa2b&"
import script from "./QuestionsCreate.vue?vue&type=script&lang=js&"
export * from "./QuestionsCreate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsCreate.vue?vue&type=style&index=0&id=621baa2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports